import { PreformattedIndexResponse, PreformattedResponse } from '@/api/resources/common/preformatted/preformatted.dto'
import { EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import axios from 'axios'

class PreformattedServices {
    async getAllPreformatted(laboratoryId: number): Promise<PreformattedIndexResponse> {
        const response = await axios.get<PreformattedIndexResponse>(`/laboratories/${laboratoryId}/preformatted/`)
        return response.data
    }

    async getAllPreformattedCompatible(laboratoryId: number, caseId: number, sampleId: number): Promise<PreformattedIndexResponse> {
        const response = await axios.get<PreformattedIndexResponse>(`laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/preformatted/compatible`)
        return response.data
    }

    async getPreformattedById(laboratoryId: number, preformattedId: number): Promise<PreformattedResponse> {
        const response = await axios.get<PreformattedResponse>(`/laboratories/${laboratoryId}/preformatted/${preformattedId}`)
        return response.data
    }

    async applyPreformattedToSampleByAdd(laboratoryId: number, caseId: number, sampleId: number, preformattedId: number, shouldCheckThatSectionsCanBeAdded: boolean): Promise<EntityIdentifierWithErrorResponse[]> {
        const params = { shouldCheckThatSectionsCanBeAdded }
        const response = await axios.put<EntityIdentifierWithErrorResponse[]>(`laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/preformatted/${preformattedId}/add`,
            null, { params })
        return response.data
    }

    async applyPreformattedToSampleByReplace(laboratoryId: number, caseId: number, sampleId: number, preformattedId: number, applyTotalReplace: boolean): Promise<EntityIdentifierWithErrorResponse[]> {
        const params = { applyTotalReplace }
        const response = await axios.put<EntityIdentifierWithErrorResponse[]>(`laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/preformatted/${preformattedId}/replace`,
            null, { params })
        return response.data
    }
}

export const preformattedServices = new PreformattedServices()
